// import external modules
import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import ErrorLayoutRoute from '../layouts/routes/errorRoutes';
import { getCookie } from '../utils/cookie';
// Full Layout
import LazyLogin from '../views/pages/login';
import LazyResetPassword from '../views/pages/resetPassword';

import ApplicationLayout from '../layouts/applicationLayout';
import EventSharedReport from '../sections/event/reports/eventSharedReport';
import EventSharedEmail from '../sections/event/emails/eventSharedEmail';
import Onboard from '../views/pages/onboard';
import Welcome from '../views/pages/welcome';
class Router extends Component {

	constructor(props) {
		super(props);
		const authToken = getCookie('authToken');
		const authenticated = authToken !== undefined;
		this.state = {
			authenticated: authenticated
		};

		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.getRegistrations().then(function (rs) { for (let reg of rs) { reg.unregister(); } });
		}
	}

	render() {
		const {
			authenticated
		} = this.state;
		return (
			<BrowserRouter basename="/">
				{!authenticated ? <Switch>
					<Route exact path="/welcome">
						<Welcome />
					</Route>
					<Route exact path="/">
						<LazyLogin />
					</Route>
					<Route exact path="/resetPassword">
						<LazyResetPassword />
					</Route>

					<Route exact path="/external/:organization/events/:event/reports/:report" render={(matchprops) => {
						return <EventSharedReport {...matchprops} />
					}} />
					<Route exact path="/external/:organization/events/:event/emails/:email" render={(matchprops) => {
						return <EventSharedEmail {...matchprops} />
					}} />
					<ErrorLayoutRoute
						render={() => (
							<Redirect
								to={{
									pathname: '/'
								}}
							/>
						)}
					/>

				</Switch> : <Switch>

					<Route exact path="/onboarding">
						<Onboard />
					</Route>
					<Route exact path="/external/:organization/events/:event/reports/:report" render={(matchprops) => {
						return <EventSharedReport {...matchprops} />
					}} />
					<Route exact path="/external/:organization/events/:event/emails/:email" render={(matchprops) => {
						return <EventSharedEmail {...matchprops} />
					}} />
					<Route path="/:organization" render={
						(matchprops) => {
							return <ApplicationLayout {...matchprops} />
						}
					}>
					</Route>

					<Route path="/" render={
						(matchprops) => {
							return <ApplicationLayout {...matchprops} />
						}
					}>
					</Route>

				</Switch>}

			</BrowserRouter>
		);
	}
}

export default Router;
